export default "__VITE_ASSET__DIHIteyE__"